<div class="tw-relative tw-h-full">

	<div class="tw-flex tw-items-end tw-justify-center tw-h-full">
  <a href="/"><img src="assets/img/CL-vertical-white.png"></a>
</div>

<router-outlet></router-outlet>

<div class="tw-fixed tw-bottom-20 tw-left-1/2 tw-transform tw-translate-x-[-50%] tw-mb-4 h-sm:tw-block tw-hidden ">
  <a href="https://thelearningbar.com/">
    <img src="assets/img/tlb-logo-230.png" alt="Logo">
  </a>
</div>
</div>
